import $ from 'jquery';
import config from './../../../config';

// Save Department
export function save_asset( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'assets/',
			data: {
                method: 'SAVE_ASSET',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_ASSET",
				asset: response
			})
		})

	}
}

export function get_assets( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'assets/',
			data: {
                method: 'GET_ASSETS',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_ASSETS",
				asset: response
			})
		})

	}
}

export function delete_assets( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'assets/',
			data: {
				method: 'DELETE_ASSETS',
				asset_id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_ASSETS",
				asset: response
			})
		})

	}
}

export function update_assets( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'assets/',
			data: {
				method: 'UPDATE_ASSETS',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_ASSETS",
				asset: response
			})
		})

	}
}

export function upload_files( data ){
	return dispatch => {
		
		$.ajax({
			method: 'POST',
			dataType : 'json',
			url: config.apiurl + 'assets/',
			data: data,
			processData: false,
			contentType: false
		}).then(function ( response ) {
			dispatch({
				type: "UPLOADED_ASSET_DOCS",
				asset: response
			})
		})

	}

}

export function onDocDelete( id, fileName ){
	return dispatch => {
		$.ajax({
			method: 'GET',
			url: config.apiurl + 'assets/',
			data: {
				method: 'DELETE_DOCS',
				id: id,
				fileName: fileName
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_DOCS",
				asset: response
			})
		})

	}

}


// WEBPACK FOOTER //
// ./src/pages/assets/actions/assets.action.js